import React from "react";
import { FaEthereum, FaShieldAlt, FaCoins, FaArrowsAltV } from "react-icons/fa";

function EthereumCompatibility() {
  return (
    <>
      <div
        className="feature-style-one-area default-padding bg-gray blurry-shape-right-bottom"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/3.png)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Features</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Why Polygon zkEVM with Xeer Technology?
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="fade-up-anim">
            <div className="row">
              <div className="col-xl-12">
                <div className="feature-style-one-items ">
                  <div className="feature-style-one ">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaEthereum size={35} />
                      </div>
                      <h4>Ethereum Compatibility</h4>
                      <p>
                        zkEVM maintains Ethereum’s structure, allowing seamless
                        migration of DApps and smart contracts.
                      </p>
                    </div>
                  </div>

                  <div className="feature-style-one ">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaShieldAlt size={35} />
                      </div>
                      <h4>Enhanced Security</h4>
                      <p>
                        Zero-knowledge rollups provide robust security,
                        preserving data privacy and protecting user assets.
                      </p>
                    </div>
                  </div>

                  <div className="feature-style-one ">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaCoins size={35} />
                      </div>
                      <h4>Cost Efficiency</h4>
                      <p>
                        Lower gas fees and faster transactions make Polygon
                        zkEVM ideal for large-scale applications.
                      </p>
                    </div>
                  </div>

                  <div className="feature-style-one ">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaArrowsAltV size={35} />
                      </div>
                      <h4>Sustainable Scaling</h4>
                      <p>
                        Polygon zkEVM is designed to meet the demands of growing
                        blockchain networks without compromising on
                        decentralization.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EthereumCompatibility;
